import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-grow-your-email-list-widget',
	templateUrl: './grow-your-email-list-widget.component.html',
	styleUrls: ['./grow-your-email-list-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class GrowYourEmailListWidgetComponent {
	@Input() author;

	get promoStacksLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/promo-stacks`;
	}

	get readerReachFacebookLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/reader-reach`;
	}

	constructor(
		private as: AnalyticsService,
		private router: Router,
	) {}

	goPromoStacks() {
		const options = {
			section: 4,
			section_headline: 'Save Time and Money',
			tile_placement: 1,
			tile_headline: 'Promo Stacks',
			cta: 'Run a Promo Stack',
			design_variant: 'Large Full Color',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.promoStacksLink]).then();
	}

	goReaderReachFacebook() {
		const options = {
			section: 4,
			section_headline: 'Save Time and Money',
			tile_placement: 2,
			tile_headline: 'Drive Facebook Traffic',
			cta: 'Run Facebook & IG Ads',
			design_variant: 'Large Full Color',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.readerReachFacebookLink]).then();
	}
}
